import { useId } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { FieldError } from '@nesso/ui/primitives/field';
import { RadioGroup } from '@nesso/ui/primitives/radio-group';

import { MAX_INPUT_FIELD_LENGTH, type UpdateClientProfileInput } from '@/entities/client';
import { ProfileFormSection } from '@/shared/ui/forms/profile-form-section';
import { PronounsFields } from '@/shared/ui/forms/pronouns-fields';
import { RadioButtonItem } from '@/shared/ui/forms/radio-button-item';

import { SEX_OPTIONS } from '../../../config/demographics.config';

export function EditClientProfileFormDemographics() {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<UpdateClientProfileInput>();
    const sexLabelId = useId();
    const sexErrorId = useId();

    return (
        <ProfileFormSection title="Demographics">
            <Controller
                control={control}
                name="sex"
                render={({ field, fieldState }) => (
                    <div className="flex flex-col gap-3">
                        <p id={sexLabelId} className="text-base">
                            Sex
                        </p>
                        <RadioGroup
                            aria-labelledby={sexLabelId}
                            aria-describedby={fieldState.error ? sexErrorId : undefined}
                            value={field.value ?? ''}
                            onValueChange={field.onChange}
                            disabled={isSubmitting}
                            className="grid grid-cols-[12.5rem] gap-6 md:gap-3 md:grid-cols-[repeat(2,12.5rem)]"
                        >
                            {SEX_OPTIONS.map((option) => (
                                <RadioButtonItem
                                    key={option.value}
                                    value={option.value}
                                    title={option.label}
                                    size="sm"
                                />
                            ))}
                        </RadioGroup>
                        <FieldError id={sexErrorId}>{fieldState.error?.message}</FieldError>
                    </div>
                )}
            />
            <PronounsFields label="Pronouns" maxLength={MAX_INPUT_FIELD_LENGTH} />
        </ProfileFormSection>
    );
}
